import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

export const listAccountPlans = async ({ page = 0, size = 20, status, accountNo, assignedTo } = {}) => {
  const params = { page, size };
  if (status) params.status = status;
  if (accountNo) params.accountNo = accountNo;
  if (assignedTo) params.assignedTo = assignedTo;
  const envelope = await requestCallCenter({
    method: "get",
    url: "account-plans",
    params,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment plans");
};

export const getAccountPlanMetadata = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "account-plans/metadata",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment plan metadata");
};

export const getAccountPlan = async (planId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `account-plans/${planId}`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load payment plan");
};

export const createAccountPlan = async (payload) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: "account-plans",
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to create payment plan");
};

export const updateAccountPlan = async (planId, payload) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: `account-plans/${planId}`,
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update payment plan");
};

export const cancelAccountPlan = async (planId) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: `account-plans/${planId}/cancel`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to cancel payment plan");
};
